module.exports = "/images/2.png?8eb8c996d612ca95bd640c20f4b71379";